$preventExtensions